import { Box, styled } from "@mui/material";

export const AccessControlMenuWrapper = styled(Box)<{ open: boolean }>(({ open }) => {
    return {
        display: open ? "block" : "none",
        "& form": {
            display: "flex",
            flexDirection: "column",
            "& .MuiFormLabel-root": {
                display: "flex",
                gap: "var(--flex-gap)",
                flexDirection: "row-reverse",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "var(--border-diluted-violet-color)",
                marginBlockStart: "var(--basic-margin)",
                borderRadius: "8px",
                padding: "var(--basic-padding)",
                cursor: "pointer",
            },
            "& .MuiFormLabel-root:last-of-type": {
                marginBlockEnd: 0,
            },
            "& .MuiInputBase-root": {
                border: "none",
                padding: 0,
                cursor: "pointer",
                flexShrink: 0,
            }
        }
    }
})